import Vue from 'vue'
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
dayjs.locale("zh-cn");
var relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(relativeTime)

/**
 * 格式化日期
 */
Vue.prototype.$dayjs = dayjs;

function dateformat(value, format = 'YYYY-MM-DD') {
    if (!value) {
        return '-';
    }
    if (value == '-') {
        return '-'
    }
    return dayjs(value).format(format);
}
Vue.prototype.$dateformat = dateformat
Vue.filter('datetime', dateformat);


const decimalFormat = function (number, fix = 2) {
    if (typeof number !== 'number') {
        return number;
    }
    return Number(number.toFixed(fix))
}
Vue.filter('decimal', decimalFormat);